var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Academy Plan")]),_c('InputSrTableCustom',{attrs:{"titlePageAuthors":_vm.Authors},on:{"authChangeHandler":_vm.authorHandler},model:{value:(_vm.table),callback:function ($$v) {_vm.table=$$v},expression:"table"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }